export const planUnitEnum = ['days', 'weeks', 'months', 'years'];

export const displayAmount = amountInPaisa => `₹ ${amountInPaisa / 100}`;
